var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteSpeakers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9791 8.30173C28.792 8.30173 29.4517 8.97614 29.4517 9.80667V18.8396C29.4517 19.6701 28.792 20.3445 27.9791 20.3445C27.1663 20.3445 26.5066 19.6701 26.5066 18.8396V9.80667C26.5066 8.97614 27.1663 8.30173 27.9791 8.30173ZM5.89035 17.3332H4.41776C3.60489 17.3332 2.94517 16.6588 2.94517 15.8282V12.8184C2.94517 11.9863 3.60489 11.3116 4.41776 11.3116H5.89035V17.3332ZM8.83552 9.41049L19.5427 3.93538C19.6563 3.87826 19.7826 3.85153 19.9096 3.85737C20.0366 3.86321 20.1599 3.90151 20.2677 3.96882C20.3756 4.03612 20.4643 4.13019 20.5253 4.24169C20.5863 4.3532 20.6176 4.47842 20.6162 4.60552V22.5343C20.6162 23.0939 20.0331 23.4548 19.5427 23.2045L8.83552 17.7308V9.41049ZM0 11.3116V17.3346C0 18.9972 1.31797 20.3445 2.94517 20.3445H5.39998L19.4161 26.7357C21.3643 27.6236 23.5614 26.1655 23.5614 23.9846V3.5072C23.5614 1.23941 21.2038 -0.212713 19.2438 0.844604L5.39998 8.30173H2.94517C1.31797 8.30173 0 9.64907 0 11.3116Z",
    fill: "#134F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteSpeakers);
export default __webpack_public_path__ + "static/media/MuteSpeakers.ae0e6f4adb9588efcb2ae96628b1c7f5.svg";
export { ForwardRef as ReactComponent };